export default function HeroSection({ banner }) {
    if (!banner) return null;

    return (
        <section className="hero-section">
            <img
                src={banner.media}
                alt={banner.title}
                className="hero-image"
                loading="lazy"
            />
            <div className="hero-text-sz">
                <h1>{banner.title}</h1>
                <p>{banner.description}</p>
            </div>
        </section>
    );
}
